// CoachScoutingReportMixin.ts

import { Component, Mixins } from 'vue-property-decorator';
import { CoachReportMixin } from '@/mixins';
import { BAEventModel } from '@/models';
import { ScoutingReportModel, ScoutingReportModelEx } from '@/models/scoutingReport/ScoutingReportModel';
import { scoutingReportApi } from "@/api/ScoutingReportApi";

@Component
export class CoachScoutingReportMixin extends Mixins(CoachReportMixin){
	scoutingReport: ScoutingReportModelEx;
	foundReport: ScoutingReportModel;
	isYouth: boolean = true;
	hasAthleteName: boolean = false;
	showPerformance: boolean = false;

	YouthLevels = [
		'1 - International',
		'2 - Pro academy',
		'3 - High performance',
		'4 - Competitive',
		'5 - Pre competitive',
	];
	SeniorLevels = [
		'1 - International Top Leagues',
		'2 - Secondary pro leagues',
		'3A - University',
		'3B - League 1',
		'3C - USL League 2',
		'4 - Senior competitive',
		'5 - Senior non competitive',
	]
	
	get PlayerPosition(): string {
		if( this.IsNotEmpty(this.scoutingReport?.playerDetails?.position) ) return this.scoutingReport.playerDetails.position;
		return this.athlete?.Position;
	}

	async createNewReport() {
		this.scoutingReport = new ScoutingReportModelEx();
	}
	async populateNewReport() {
		await this.scoutingReport.fromIds(this.athleteId, this.coachId, this.teamId, this.athletesCache, this.coachesCache, this.teamsCache, this.orgsCache, this.sportsCache);
	}
	async findReport() {
		this.foundReport = await scoutingReportApi.findById( this.reportId );
		this.scoutingReport = new ScoutingReportModelEx();
	}
    async updateReport() {
		// this.scoutingReport.updateReport();
	}
	async updateFromReport() {
		await this.scoutingReport.fromReport(this.foundReport, this.athletesCache, this.coachesCache, this.teamsCache, this.orgsCache, this.sportsCache);
	}
	async updateOnChange() {
		this.showPerformance = false;
		this.isYouth = this.IsEmpty(this.scoutingReport?.playerDetails?.competitiveLevel) || this.YouthLevels.includes(this.scoutingReport.playerDetails.competitiveLevel);
		this.scoutingReport.ComputePerformanceScore();
		if( this.scoutingReport.evaluation?.performance?.score ) this.showPerformance = this.scoutingReport.evaluation.performance.score > 1;
		this.hasAthleteName = this.IsNotEmpty(this.scoutingReport?.AthleteName);

		this.isReportComplete = true;
		if( !this.hasAthleteName ) this.isReportComplete = false;
		for( const category of this.scoutingReport.evaluation.athleteAttributes) if( this.IsEmpty(category.score) ) this.isReportComplete = false;
		for( const category of this.scoutingReport.evaluation.gameMoments) if( this.IsEmpty(category.score) ) this.isReportComplete = false;
		for( const category of this.scoutingReport.evaluation.scoutingEval) if( this.IsEmpty(category.score) ) this.isReportComplete = false;
		if( this.scoutingReport.evaluation.potential.score < 1 ) this.isReportComplete = false;
	}
    async onSubmitStart() {}
    async onEventLoaded(event: BAEventModel) {}

	ScoutingLabel(name: string, length: number = 6): string {
		if( this.IsEmpty(name) ) return '-';

		const keywords = ['Tactical', 'Technical', 'Mental', 'Physical']
		const lowerKeywords = keywords.map(k => k.toLowerCase());
		const trimmedName = name.trim();

		// Case-insensitive match with keyword
		if (lowerKeywords.includes(trimmedName.toLowerCase())) {
			return trimmedName;
		}

		// Name is short enough
		if (trimmedName.length < 9) {
			return trimmedName;
		}

		// Name has multiple words → return acronym
		const words = trimmedName.split(/\s+/);
		if (words.length > 1) {
			return words.map(w => w[0].toUpperCase()).join('');
		}

		// Fallback → return first N letters
		return trimmedName.substring(0, length);
	}
}
